define('bwp/main',[
  'jquery',
  'bootstrap/transition',
  'bootstrap/collapse',
  'bootstrap/modal',

  './social/facebook',
  './social/google',
  './social/pinterest',
  './social/twitter'
], function($) {

  return $;
});
define('bwp', ['bwp/main'], function (main) { return main; });

